import React from "react";

function PrivacyPolicy() {
  return (
    <section className="privacy-policy container py-5">
      <h1>Politika privatnosti</h1>

      <h2>1. Voditelj obrade podataka</h2>
      <p>
        <strong>Naziv:</strong> Future Energy Solutions d.o.o.
      </p>
      <p>
        <strong>Adresa:</strong> Šandora Petefija 48., 31327 Kopačevo, Hrvatska
      </p>
      <p>
        <strong>Email:</strong> info@fues.hr
      </p>
      <p>
        <strong>Web stranica:</strong>{" "}
        <a href="https://fues.hr">
          fues.hr
        </a>
      </p>

      <h2>2. Koje podatke prikupljamo?</h2>
      <p>
        Putem kontakt formi na našoj web stranici prikupljamo sljedeće podatke:
      </p>
      <ul>
        <li>Ime</li>
        <li>Prezime</li>
        <li>Email adresa</li>
      </ul>

      <h2>3. Kako prikupljamo podatke?</h2>
      <p>
        Podatke prikupljamo isključivo putem kontakt formi koje korisnik
        samostalno i dobrovoljno ispunjava.
      </p>

      <h2>4. Svrha obrade podataka</h2>
      <p>Vaše osobne podatke koristimo isključivo za:</p>
      <ul>
        <li>Odgovor na vaš upit</li>
        <li>Slanje ponuda i informacija vezanih uz naše usluge</li>
      </ul>

      <h2>5. Dijeljenje podataka</h2>
      <p>
        Vaše osobne podatke <strong>ne dijelimo s trećim stranama</strong>.
      </p>

      <h2>6. Pohrana podataka</h2>
      <p>
        Prikupljeni podaci pohranjuju se u sustavu e-pošte, koji se temelji na
        cloud infrastrukturi. Podaci se čuvaju{" "}
        <strong>do povlačenja privole</strong>, odnosno zahtjeva za brisanjem.
      </p>

      <h2>7. Prava korisnika</h2>
      <p>Kao korisnik imate pravo na:</p>
      <ul>
        <li>Pristup osobnim podacima</li>
        <li>Ispravak netočnih podataka</li>
        <li>Brisanje podataka</li>
        <li>Ograničenje obrade</li>
        <li>Prijenos podataka</li>
        <li>Ulaganje prigovora</li>
      </ul>
      <p>
        Za ostvarivanje bilo kojeg od navedenih prava možete nas kontaktirati
        putem emaila: <strong>info@fues.hr</strong>
      </p>

      <h2>8. Kolačići</h2>
      <p>
        Naša web stranica koristi{" "}
        <strong>isključivo funkcionalne kolačiće</strong> za pravilan rad
        stranice. Postavljen je <strong>cookie banner</strong> koji omogućuje
        informirano prihvaćanje upotrebe kolačića.
      </p>

      <h2>9. Maloljetni korisnici</h2>
      <p>
        Naše usluge nisu namijenjene osobama mlađima od 18 godina. Ne
        prikupljamo svjesno podatke maloljetnih osoba.
      </p>

      <h2>10. Newsletter i korisnički računi</h2>
      <p>
        Naša web stranica <strong>ne koristi newsletter sustav</strong> niti
        omogućuje <strong>registraciju korisničkih računa</strong>.
      </p>

      <p>
        Za dodatne informacije slobodno nas kontaktirajte putem emaila:{" "}
        <strong>info@fues.hr</strong>
      </p>
    </section>
  );
}

export default PrivacyPolicy;
